<template>
  <div class="page page-roadshow-list">
    <div class="list-options v-mt-sm">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item :colon="false" label="通知范围">
              <a-select placeholder="请选择" v-model="form.role" size="default" style="width: 200px" allowClear>
                <a-select-option value="U01">合作项目申请人</a-select-option>
                <a-select-option value="U02">螺蛳壳改造施工方</a-select-option>
                <a-select-option value="U03">山区学校</a-select-option>
                <a-select-option value="U04">山区学校合作伙伴</a-select-option>
                <a-select-option value="U05">螺蛳壳改造评审专家</a-select-option>
                <a-select-option value="U06">精灵书屋评审专家</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="通知标题"><a-input placeholder="标题" @keyup.enter="handleSearch" allow-clear v-model="form.title" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="状态">
              <a-select placeholder="请选择" v-model="form.state" size="default" style="width: 200px" allowClear>
                <a-select-option :value="1">已发布</a-select-option>
                <a-select-option :value="0">待发布</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <div class="v-ml-auto">
        <a-space>
          <a-button type="primary" icon="search" size="small" @click="handleSearch">查询</a-button>
          <a-button icon="plus" type="indigo" size="small" @click="$router.push('draft')">新增通知</a-button>
          <!-- <a-button icon="file-excel" type="danger" size="small" @click="$router.push('add')">导出</a-button> -->
        </a-space>
      </div>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="id">
        <a-table-column title="#" data-index="index" :width="60" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="通知标题" :ellipsis="true" data-index="title" align="left" />
        <a-table-column title="通知范围" :width="330" data-index="roles">
          <template slot-scope="text, record" v-if="record.roles">
            <!-- <div v-for="item in record.roles.split(',')" :key="item"> -->
            <a-tag color="purple" v-for="item in record.roles.split(',')" :key="item">
              <template v-if="item == 'U01'">合作项目申请人</template>
              <template v-else-if="item == 'U02'">螺蛳壳改造施工方</template>
              <template v-else-if="item == 'U03'">山区学校</template>
              <template v-else-if="item == 'U04'">山区学校合作伙伴</template>
              <template v-else-if="item == 'U05'">螺蛳壳改造评审专家</template>
              <template v-else-if="item == 'U06'">精灵书屋评审专家</template>
            </a-tag>
            <!-- </div> -->
          </template>
        </a-table-column>
        <a-table-column title="状态" :width="80" data-index="state" align="left">
          <template slot-scope="text, record">
            <span v-if="record.state == 1">已发布</span>
            <span class="text-grey" v-else>待发布</span>
          </template>
        </a-table-column>
        <a-table-column title="发布时间" :width="120" data-index="publishTime" align="left">
          <template slot-scope="text, record">
            <template>{{ record.publishTime ? record.publishTime.substring(0, 16) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="创建时间" :width="140" data-index="createTime" align="left">
          <template slot-scope="text, record">
            <template>{{ record.createTime ? record.createTime.substring(0, 16) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="action" :width="100" align="center">
          <template slot-scope="text, record">
            <a-space :size="10">
              <template v-if="record.state == 0">
                <span class="text-indigo font-13 hover-line" title="修改" @click="$router.push(`draft?id=${record.noticeId}`)">修改</span>
                <span class="text-red font-13 hover-line" title="删除" @click="onRemove(record.noticeId)">删除</span>
              </template>
              <span class="text-indigo font-13 hover-line" title="查看" @click="$router.push(`detail?id=${record.noticeId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const form = {
  title: '',
  state: undefined,
  visible: true,
  sortNo: 1,
}
import { listNotice, saveNotice, delNotice } from '@/api/system/notice'
export default {
  data() {
    return {
      loading: false,
      saving: false,
      modalVisible: false,
      list: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      form: {
        subject: undefined,
        visible: undefined,
        activityName: '',
      },
      saveForm: {
        ...form,
      },
    }
  },
  methods: {
    handleSearch() {
      this.load()
    },
    handleReset() {
      this.form.resetFields()
    },
    load(page = 1, pageSize = 10, sorter) {
      this.loading = true
      let params = {
        page,
        pageSize,
        sorter,
        ...this.form,
      }
      listNotice(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onPageChange(page, pageSize) {
      this.load(page, pageSize)
    },
    openModal() {
      this.saveForm = {
        ...form,
      }
      this.modalVisible = true
    },
    cancelModal() {
      this.modalVisible = false
    },
    handleSubmit() {
      let { id, projectType, activityName, visible, sortNo } = this.saveForm
      this.$message.destroy()
      if (!projectType) {
        this.$message.warning('请选择项目类型')
        this.$refs.projectType.focus()
        return
      }
      if (activityName.trim() === '') {
        this.$message.warning('请输入活动名称')
        this.$refs.activityName.focus()
        return
      }
      if (!sortNo) {
        this.$message.warning('请输入排序值')
        this.$refs.sortNo.focus()
        return
      }
      this.saving = true
      let params = {
        id,
        projectType,
        activityName,
        isVisible: ~~visible,
        sortNo,
      }
      saveNotice(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('保存成功')
            this.load()
            this.cancelModal()
          }
          this.saving = false
        })
        .catch(() => {
          this.saving = false
        })
    },
    onUpdate(record) {
      this.saveForm = { ...record, visible: !!record.isVisible }
      this.modalVisible = true
    },
    onRemove(id) {
      let vm = this
      this.$confirm({
        title: '确认删除该记录？',
        onOk: () => {
          delNotice(id).then(({ data }) => {
            if (data.success) {
              vm.$message.success('操作成功')
              vm.load()
            }
          })
        },
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style lang="stylus" scoped>
.ant-form-item-label
  min-width 100px
</style>
